(function() {
	'use strict';

	angular.module('claimsApp').controller('ClaimRegistrationGamController',
			ClaimRegistrationGamController);

	ClaimRegistrationGamController.$inject = [ '$scope', '$state', '$log','$base64','$resource','NgTableParams','ClaimRegistration','Upload','authExpiredInterceptor','AlertService','$stateParams','MyTask','$uibModal','$window','FileNetService','$timeout', 'CommonService' ];

	function ClaimRegistrationGamController($scope, $state, $log,$base64, $resource,NgTableParams,ClaimRegistration,Upload,authExpiredInterceptor,AlertService,$stateParams,MyTask,$uibModal,$window,FileNetService,$timeout, CommonService) {
		
		var param = $stateParams;
		
		// init all data
		var claimRegistrationGamCtr = this;
		
		var self = $scope;
		
		claimRegistrationGamCtr.claimCase  = {
			
		};
		
		claimRegistrationGamCtr.searchCompleted = true;
		
		claimRegistrationGamCtr.disableSentBtn = false;
		
		claimRegistrationGamCtr.disableAll = false;
		
		claimRegistrationGamCtr.policyIsTPDAndRO1 = false;
		
		claimRegistrationGamCtr.laList = [];
		
		claimRegistrationGamCtr.agentList = [];
		
		claimRegistrationGamCtr.reasons = [];
		
		claimRegistrationGamCtr.hospitals = [];

		claimRegistrationGamCtr.datePickerOpenStatus = {};
		
		claimRegistrationGamCtr.documentRequireds = [];

		claimRegistrationGamCtr.paymentMethods = [];
		
		claimRegistrationGamCtr.afterPrint = false;
		
		claimRegistrationGamCtr.inState = function(state) {
			return $state.includes(state);
		}

		
		claimRegistrationGamCtr.init = function() {
			var txnId = $base64.decode(param.txnId);
			var taskInstanceId = $base64.decode(param.taskId);
			claimRegistrationGamCtr.taskInstanceId = taskInstanceId;
			ClaimRegistration.getClaimPayMethod({},function(result){
				claimRegistrationGamCtr.paymentMethods = result;
			});
			ClaimRegistration.getClaimCase({txnId:txnId},function(result){
				claimRegistrationGamCtr.claimCase = result;
				if(result.issuingDate != null && result.issuingDate != '') {
					claimRegistrationGamCtr.claimCase.issuingDate = new Date(result.issuingDate);
				}
				if(result.dob != null && result.dob != '') {
					claimRegistrationGamCtr.claimCase.dob = new Date(result.dob);
				}
				claimRegistrationGamCtr.claimCase.idNum = result.idNum;
				claimRegistrationGamCtr.claimCase.taskInstanceId = taskInstanceId;
				ClaimRegistration.getReasons({claimType:claimRegistrationGamCtr.claimCase.claimType},function(result){
					claimRegistrationGamCtr.reasons = result;
				});
				if(claimRegistrationGamCtr.claimCase.claimType =='MED'){
					ClaimRegistration.getSurgeries({},function(result){
						claimRegistrationGamCtr.surgeries = result;
					});
					
					ClaimRegistration.getHospitals({},function(result){
						claimRegistrationGamCtr.hospitals = result;
					});
				}
				//reset document list
				claimRegistrationGamCtr.docList = claimRegistrationGamCtr.claimCase.docList;
				claimRegistrationGamCtr.originalDocList = angular.copy(claimRegistrationGamCtr.docList);
				
				
				claimRegistrationGamCtr.docParams = new NgTableParams({
					count: 10000000000
				}, {
					 counts : [],
					 dataset: angular.copy(claimRegistrationGamCtr.originalDocList)
				});
				
				ClaimRegistration.getDocumentByType({claimType:claimRegistrationGamCtr.claimCase.claimType},function(result){
					claimRegistrationGamCtr.documents = result;
				})
				
				ClaimRegistration.getPolicyLas({policyNum:claimRegistrationGamCtr.claimCase.policyNum},function(result){
					claimRegistrationGamCtr.laList = result;
				});
				if(claimRegistrationGamCtr.claimCase.cancelled) {
					claimRegistrationGamCtr.disableAll = true;
				}
				if(claimRegistrationGamCtr.claimCase.claimType == 'TPD' && claimRegistrationGamCtr.claimCase.poType == 'RO1') {
					claimRegistrationGamCtr.policyIsTPDAndRO1 = true;
				}
				
				CommonService.query({
					masterurl : 'get-all-bank-las'
				}, function(result) {
					claimRegistrationGamCtr.bankList = result;
				}).$promise.then(function() {
					claimRegistrationGamCtr.getBranchBank();
				});
				if(claimRegistrationGamCtr.claimCase.paymentMethod == '2A' || claimRegistrationGamCtr.claimCase.paymentMethod == '2B') {
					ClaimRegistration.getClaimPolicyMethod({poNum : claimRegistrationGamCtr.claimCase.poNum}, function(result) {
						claimRegistrationGamCtr.policyList = result;
					});
				}
			});
			
		}
		
		// checkSignature from kofax
		claimRegistrationGamCtr.checkSignature = function (policyNum){
			if (policyNum == undefined || policyNum == null) return false;
			FileNetService.query({method:'get-list-poldoc',polNum:policyNum}, function(result){
				claimRegistrationGamCtr.animationsEnabled = true;
				var modalInstance = 
				//show dialog
				$uibModal.open({
					animation : claimRegistrationGamCtr.animationsEnabled,
					templateUrl : GLOBAL_URL+'partial?uri=ga/signature/signature-dialog',
					controller : 'SignatureDialogController as signatureDlgCtrl',
					size : 'lg',
					resolve : {
						items : function() {
							return result;//tranfer data for dialog
						}
					}
				});
				modalInstance.result.then(
				function(result) {
				},
				function(error){
				});
    		},
    		function(error){
    		});
		}
		
		
		claimRegistrationGamCtr.returnTask = function(){
			if(claimRegistrationGamCtr.taskInstanceId){
				var uri = 'task/#/my-task';
				MyTask.release({
					taskId : claimRegistrationGamCtr.taskInstanceId
				}, function(result) {
					$window.open(GLOBAL_URL + uri, '_self')
				})
			}
		}
		claimRegistrationGamCtr.cancel = function(){
			var modalInstance = 
				//show dialog
				$uibModal.open({
					templateUrl : GLOBAL_URL+'partial?uri=ga/claims/registration/claim-registration-gam-cancel-dialog',
					controller : 'ClaimRegistrationGAMCancelDialogController as claimsCancelTaskCtr',
					size : 'lg',
					resolve : {
						claimCase : claimRegistrationGamCtr.claimCase
					}
			});
			modalInstance.result.then(
					function(result) {
						claimRegistrationGamCtr.disableAll= true;
					},
					function(error){
						
					});
		}
		
		claimRegistrationGamCtr.changeDoc = function(row){
			if(!row.documentCode) {
				row.documentName = '';
				return;
			}
			angular.forEach(claimRegistrationGamCtr.documents,function(doc){
				if(doc.documentCode ==row.documentCode) {
					row.documentName = doc.documentName;
				}
			})
		}
		
		claimRegistrationGamCtr.openCalendar = function(date) {
			claimRegistrationGamCtr.datePickerOpenStatus[date] = true;
		}
		claimRegistrationGamCtr.openCalendar1 = function(row) {
			row.isOpen = true;
		}
		
		claimRegistrationGamCtr.agentInfo = function (){
			if(claimRegistrationGamCtr.claimCase && claimRegistrationGamCtr.claimCase.agent) {
				return claimRegistrationGamCtr.claimCase.agent.agentCode + " - "+ claimRegistrationGamCtr.claimCase.agent.agentName;
			}
		}
		
		claimRegistrationGamCtr.changeClaimType = function(){
			claimRegistrationGamCtr.claimCase.reason=null;
			claimRegistrationGamCtr.claimCase.claimReasonList = null;
			ClaimRegistration.checkCanClaim({claimType:claimRegistrationGamCtr.claimCase.claimType,policyNum : claimRegistrationGamCtr.claimCase.policyNum},function(result){
				
			});
			ClaimRegistration.getReasons({claimType:claimRegistrationGamCtr.claimCase.claimType},function(result){
				claimRegistrationGamCtr.reasons = result;
			});
			if(claimRegistrationGamCtr.claimCase.claimType =='MED'){
				ClaimRegistration.getSurgeries({},function(result){
					claimRegistrationGamCtr.surgeries = result;
				});
				
				ClaimRegistration.getHospitals({},function(result){
					claimRegistrationGamCtr.hospitals = result;
				});
			};
			//reset document list
			claimRegistrationGamCtr.docList = [];
			claimRegistrationGamCtr.originalDocList = angular.copy(claimRegistrationGamCtr.docList);
			
			//load basic document
			ClaimRegistration.getDocumentRequireds({claimType:claimRegistrationGamCtr.claimCase.claimType},function(result){
				claimRegistrationGamCtr.documentRequireds = result;
				angular.forEach(result, function(document) {
						claimRegistrationGamCtr.docList.push({documentCode:document.documentCode,documentName:document.documentName,no:0,receivedDate:null,remark:null,invalid:false});
				});
				claimRegistrationGamCtr.originalDocList = angular.copy(claimRegistrationGamCtr.docList);
				claimRegistrationGamCtr.docParams = new NgTableParams({
					count: 10000000000
				}, {
					 counts : [],
					 dataset: angular.copy(claimRegistrationGamCtr.originalDocList)
				});
			})
			ClaimRegistration.getDocumentByType({claimType:claimRegistrationGamCtr.claimCase.claimType},function(result){
				claimRegistrationGamCtr.documents = result;
			})
			if(claimRegistrationGamCtr.claimCase.claimType =='TPD' && claimRegistrationGamCtr.claimCase.poType == 'RO1') {
				claimRegistrationGamCtr.claimCase.accidentIndicator = true;
				claimRegistrationGamCtr.policyIsTPDAndRO1 = true;
			}else {
				claimRegistrationGamCtr.claimCase.accidentIndicator = false;
				claimRegistrationGamCtr.policyIsTPDAndRO1 = false;
			}
		};
		
		claimRegistrationGamCtr.removeFileAttach = function(file, errFiles){
			$log.debug('removeFileAttach');
			if(file) {
				claimRegistrationGamCtr.claimCase.attachmentFileName = null;
			}
		}
		
		claimRegistrationGamCtr.setDocCompletedDate = function(){
				var latestDate = null;
				angular.forEach(claimRegistrationGamCtr.documentRequireds, function(documentRequired) {
					var endDate = null;
					angular.forEach(claimRegistrationGamCtr.originalDocList,function(document){
						if(documentRequired.documentCode==document.documentCode){
	                        if(document.receivedDate!=null&&(document.invalid==null||!document.invalid)) {
	                            if(endDate==null ||endDate < document.receivedDate){
	                                endDate = document.receivedDate;
	                            }
	                        }
	                    }
					})
	                if(endDate==null) {
	                	claimRegistrationGamCtr.claimCase.docCompletedDate = null;
	                    return;
	                }else if(latestDate==null ||latestDate< endDate) {
	                        latestDate = endDate;
	                }
				})
				claimRegistrationGamCtr.claimCase.docCompletedDate = latestDate;
		}
		
		
		claimRegistrationGamCtr.changeNoInRow =function(row) {
			if(row.receivedDate == null) row.receivedDate = new Date();
		};
		
		claimRegistrationGamCtr.datepickerOptions = {};
		claimRegistrationGamCtr.datepickerOptions.docCompletedDate = {
	            maxDate: new Date()
	    };
		
		// max date picker
		claimRegistrationGamCtr.datepickerOptions.eventDate = {
	            maxDate : new Date()
	    };
		
		 // min date picker
		claimRegistrationGamCtr.datepickerOptions.hopitalStartDate = {
	        	minDate: null,
	            maxDate: new Date()
	    };

	    // max date picker
		claimRegistrationGamCtr.datepickerOptions.hopitalEndDate = {
	            minDate: null,
	            maxDate : new Date()
	    };
		
		// max date picker
		claimRegistrationGamCtr.datepickerOptions.receivedDate = {
	            maxDate : new Date()
	    };
		
		// watch min and max dates to calculate difference
	    var unwatchMinMaxValues = $scope.$watchCollection('[claimRegistrationGamCtr.claimCase.hopitalStartDate, claimRegistrationGamCtr.claimCase.hopitalEndDate]',
	       function() {
	        // min max dates
	    	if(claimRegistrationGamCtr.claimCase.hopitalEndDate){
	    		claimRegistrationGamCtr.datepickerOptions.hopitalStartDate.maxDate = claimRegistrationGamCtr.claimCase.hopitalEndDate;
	    	}
	    	if(claimRegistrationGamCtr.claimCase.hopitalStartDate){
	    		claimRegistrationGamCtr.datepickerOptions.hopitalEndDate.minDate = claimRegistrationGamCtr.claimCase.hopitalStartDate;
	    	}
	    }, true);
	    
	    // destroy watcher
	    $scope.$on('$destroy', function() {
	        unwatchMinMaxValues();
	    });
		
	    
		claimRegistrationGamCtr.openPolicyInfo =  function(policyNum) {
    		var uri = null;
    		var number = null;
    		if (policyNum) {
    			uri = 'ga/history/#/constractInfo/';
    			number = $base64.encode(policyNum);
    		}
    		uri = uri.concat(number);
    		$window.open(GLOBAL_URL + uri, '_self')
    	}
		
		claimRegistrationGamCtr.checkDuplicateDocument = function (){
				var arrExist = [];
				var exist = false;
		    	angular.forEach(claimRegistrationGamCtr.originalDocList, function (doc) {
		    	    if (arrExist.indexOf(doc.documentCode)>=0) {
		    	    	self.addAlert('Hồ sơ ['+doc.documentName+'] bị trùng. Vui lòng kiểm tra lại','danger');
		    	    	exist = true;
		    	    } else {
		    	    	arrExist.push(doc.documentCode);
		    	    }
		    	});
		    	return exist;
		    }
		
		claimRegistrationGamCtr.registration = function(){
			if(claimRegistrationGamCtr.checkDuplicateDocument()){
				return;
			}
			var data = [];
			claimRegistrationGamCtr.disableSentBtn = true;
			claimRegistrationGamCtr.disableAll = true;
			claimRegistrationGamCtr.claimCase.docList = claimRegistrationGamCtr.originalDocList;
			for (var int = 0; int < claimRegistrationGamCtr.docParams.data.length; int++) {
				if(claimRegistrationGamCtr.claimCase.docList[int].attachment){
					data[claimRegistrationGamCtr.claimCase.docList[int].documentCode] = claimRegistrationGamCtr.docParams.data[int].attachment;
				}
			}
			var json = JSON.stringify(claimRegistrationGamCtr.claimCase);
			$log.debug(json);
			data['claimCaseDTO'] = new Blob([json], {type: "application/json"});
			
			 Upload.upload({
		            url: GLOBAL_URL + 'api/ga/claims/registration/do-update-claim-case-gam?access_token=' + authExpiredInterceptor.getToken(),
		            data: data
		        }).then(function (resp) {
		            //$log.debug('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
		            $timeout(function(){
		            	$window.open(GLOBAL_URL +"ga/claims/gen-ack-letter/"+$base64.encode(resp.data.claimCaseId)+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
		            },3000);
		        }, function (resp) {
		        	$log.debug('Error status: ' + resp.status);
		        	claimRegistrationGamCtr.disableSentBtn = false;
					claimRegistrationGamCtr.disableAll = false;
		        }, function (evt) {
		           /* var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
		            $log.debug('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);*/
		        });		
		}

		claimRegistrationGamCtr.deleteCount = 0;

		claimRegistrationGamCtr.documents = [];
		claimRegistrationGamCtr.docList = [];

		claimRegistrationGamCtr.originalDocList = angular.copy(claimRegistrationGamCtr.docList);

		
		claimRegistrationGamCtr.docParams = new NgTableParams({
			count: 10000000000
		}, {
			 counts : [],
			 dataset: angular.copy(claimRegistrationGamCtr.originalDocList)
		});
		
		claimRegistrationGamCtr.add = function() {
		      claimRegistrationGamCtr.isEditing = true;
		      claimRegistrationGamCtr.isAdding = true;
		      claimRegistrationGamCtr.docParams.settings().dataset.unshift({doc:{},no:1,receivedDate:new Date(),remark:'',invalid:false});
		      // we need to ensure the user sees the new row we've just added.
		      // it seems a poor but reliable choice to remove sorting and move them to the first page
		      // where we know that our new item was added to
		      claimRegistrationGamCtr.docParams.sorting({});
		      claimRegistrationGamCtr.docParams.page(1);
		      claimRegistrationGamCtr.docParams.reload();
		}

		claimRegistrationGamCtr.cancelChanges = function() {
		      claimRegistrationGamCtr.resetTableStatus();
		      var currentPage = claimRegistrationGamCtr.docParams.page();
		      claimRegistrationGamCtr.docParams.settings({
		        dataset: claimRegistrationGamCtr.originalDocList
		      });
		      // keep the user on the current page when we can
		      if (!claimRegistrationGamCtr.isAdding) {
		        claimRegistrationGamCtr.docParams.page(currentPage);
		      }
		    }

		claimRegistrationGamCtr.del = function(row) {
		      _.remove(claimRegistrationGamCtr.docParams.settings().dataset, function(item) {
		        return row === item;
		      });
		      claimRegistrationGamCtr.deleteCount++;
		      claimRegistrationGamCtr.tableTracker.untrack(row);
		      claimRegistrationGamCtr.docParams.reload().then(function(data) {
		        if (data.length === 0 && claimRegistrationGamCtr.docParams.total() > 0) {
		          claimRegistrationGamCtr.docParams.page(claimRegistrationGamCtr.docParams.page() - 1);
		          claimRegistrationGamCtr.docParams.reload();
		        }
		      });
		 }

		claimRegistrationGamCtr.hasChanges = function() {
		      return claimRegistrationGamCtr.tableForm.$dirty || claimRegistrationGamCtr.deleteCount > 0;
		 }

		claimRegistrationGamCtr.resetTableStatus = function() {
		      claimRegistrationGamCtr.isEditing = false;
		      claimRegistrationGamCtr.isAdding = false;
		      claimRegistrationGamCtr.deleteCount = 0;
		      claimRegistrationGamCtr.tableTracker.reset();
		      claimRegistrationGamCtr.tableForm.$setPristine();
		    }

		claimRegistrationGamCtr.saveChanges = function() {
	      claimRegistrationGamCtr.resetTableStatus();
	      var currentPage = claimRegistrationGamCtr.docParams.page();
	      claimRegistrationGamCtr.originalDocList = claimRegistrationGamCtr.docParams.settings().dataset;
	      claimRegistrationGamCtr.setDocCompletedDate();
	    }
		
		claimRegistrationGamCtr.checkEventDate = function(){
			var currentDate = new Date();
			if (Number($filter('date')(claimRegistrationGamCtr.claimCase.eventDate,'yyyyMMdd')) <= Number($filter('date')(currentDate, 'yyyyMMdd'))) {
				claimRegistrationGamCtr.form.eventDate.$setValidity('dateBiggerCurrentDate',true);	
	        }
	        else{
	        	claimRegistrationGamCtr.form.eventDate.$setValidity('dateBiggerCurrentDate',false);
	        }
		}
		
		claimRegistrationGamCtr.checkHopitalStartDate =function(){
			if (claimRegistrationGamCtr.claimCase.hopitalEndDate!=null && Number($filter('date')(claimRegistrationGamCtr.claimCase.hopitalEndDate,'yyyyMMdd')) < Number($filter('date')(claimRegistrationGamCtr.claimCase.hopitalStartDate, 'yyyyMMdd'))) {
				claimRegistrationGamCtr.form.hopitalStartDate.$setValidity('dateBiggerHospitalEndDate',false);	
	        }
	        else{
	        	claimRegistrationGamCtr.form.hopitalStartDate.$setValidity('dateBiggerHospitalEndDate',true);
	        }
		}
		
		claimRegistrationGamCtr.checkHopitalEndDate =function(){
			var currentDate = new Date();
			if (Number($filter('date')(claimRegistrationGamCtr.claimCase.hopitalEndDate,'yyyyMMdd')) <= Number($filter('date')(currentDate, 'yyyyMMdd'))) {
				claimRegistrationGamCtr.form.hopitalEndDate.$setValidity('dateBiggerCurrentDate',true);	
	        }
	        else{
	        	claimRegistrationGamCtr.form.hopitalEndDate.$setValidity('dateBiggerCurrentDate',false);	
	        }
			if (claimRegistrationGamCtr.claimCase.hopitalStartDate!=null && Number($filter('date')(claimRegistrationGamCtr.claimCase.hopitalEndDate,'yyyyMMdd')) < Number($filter('date')(claimRegistrationGamCtr.claimCase.hopitalStartDate, 'yyyyMMdd'))) {
				claimRegistrationGamCtr.form.hopitalEndDate.$setValidity('dateSmallerHospitalStartDate',false);	
	        }
	        else{
	        	claimRegistrationGamCtr.form.hopitalEndDate.$setValidity('dateSmallerHospitalStartDate',true);
	        }
		}
		
		claimRegistrationGamCtr.changeReason = function(item) {
			var reasonCode = item.claimReasonCode;
			var claimType = claimRegistrationGamCtr.claimCase.claimType;
			var policyNum =  claimRegistrationGamCtr.claimCase.policyNum;
			var laNum = claimRegistrationGamCtr.claimCase.la.clientNum;
			if(reasonCode&&claimType&&policyNum&&laNum){
				ClaimRegistration.checkPaymentOnSpot({reasonCode:reasonCode,claimType:claimType,policyNum:policyNum,laNum:laNum},function(result){
					if(result.paymentOnSpot) {
						claimRegistrationGamCtr.claimCase.paymentOnSpotIndicator = true;
					}
				})
			}
		}
		
		claimRegistrationGamCtr.changePaymentMethod = function() {
			// alert(claimRegistrationGamCtr.claimCase.paymentMethod);
			claimRegistrationGamCtr.claimCase.bankCode = null;
			claimRegistrationGamCtr.claimCase.branchBankCode = null;
			claimRegistrationGamCtr.claimCase.address = null;
			claimRegistrationGamCtr.claimCase.dob = null;
			claimRegistrationGamCtr.claimCase.relationShip = null;
			claimRegistrationGamCtr.claimCase.differentPO = false;
			if(claimRegistrationGamCtr.claimCase.paymentMethod == 2) {
				ClaimRegistration.getClaimPolicyMethod({poNum : claimRegistrationGamCtr.claimCase.poNum}, function(result) {
					claimRegistrationGamCtr.policyList = result;
				});
			}
		};

		claimRegistrationGamCtr.getBranchBank = function() {
			if (claimRegistrationGamCtr.claimCase.bankCode != undefined
					&& claimRegistrationGamCtr.claimCase.bankCode != null
					&& claimRegistrationGamCtr.claimCase.bankCode != '') {
				CommonService.query({
					masterurl : 'get-all-branch-las',
					bankCode : claimRegistrationGamCtr.claimCase.bankCode
				}, function(result) {
					claimRegistrationGamCtr.branchBankList = result;
				});
			}
		};

		claimRegistrationGamCtr.getBranchAddress = function() {
			if (claimRegistrationGamCtr.claimCase.branchBankCode != undefined
					&& claimRegistrationGamCtr.claimCase.branchBankCode != null
					&& claimRegistrationGamCtr.claimCase.branchBankCode != '') {
				CommonService
						.get(
								{
									masterurl : 'get-address-bank-branch',
									bankBranchCode : claimRegistrationGamCtr.claimCase.branchBankCode
								},
								function(result) {
									claimRegistrationGamCtr.claimCase.bankAddress = result.name;
								});
			}
		};
		
		var modalInstance = null;
		
		claimRegistrationGamCtr.openDialog = function() {
			modalInstance = $uibModal.open({
				animation : true,
				templateUrl : GLOBAL_URL
						+ 'partial?uri=ga/claims/registration/claim-confirm-modal',
				controller : 'ClaimDialogController',
				controllerAs : 'vm',
				size : 'sm',
				backdrop: 'static'
			});
			modalInstance.result.then(function(check) {
				claimRegistrationGamCtr.claimCase.differentPO = check;
			}, function() {
			});
		};
		
		claimRegistrationGamCtr.doPrintClaimRequestInfo = function() {
			ClaimRegistration.download({},claimRegistrationGamCtr.claimCase, function(result) {
				claimRegistrationGamCtr.afterPrint = true;
			},function(error){
				$scope.addAlert('Vui lòng nhập đủ thông tin trước khi in phiêu yêu cầu.','danger');
			});
		};
		
		claimRegistrationGamCtr.viewFile = function(){
	        	if(claimRegistrationGamCtr.claimCase.txnId != undefined){
	        		var id = claimRegistrationGamCtr.claimCase.txnId;
	        		var globalUrl = GLOBAL_URL+'ga/claims/view-pdf?txnId='+id;
	        		var modalInstance = 
						//show dialog
						$uibModal.open({
							animation : true,
							windowClass: 'modalLv2',
							templateUrl : GLOBAL_URL+'ga/claims/view-file?txnId='+id+'&globalUrl='+globalUrl,
							controller : 'ClaimShowFileController as claimShowFileCtrl',
							size : 'lg',
							
							resolve : {
								id : function() {
									return id;//tranfer data for dialog
								}
							}
					});
					modalInstance.result.then(
							function(result) {
								console.log(result);
							},
							function(error){
								
							});
	        	}
	    	}

	}
})();
